import React from 'react';
import { Paper, Typography, Grid, Button } from '@material-ui/core';
import Page from './Page';
import IPButton from '../layout/IPButton';

const style = {
  mc: {
    padding: 16,
    background: "#261b12 url('./dirt.png')",
    color: 'white',
    fontFamily: 'minecraftmedium',
  },
  content: {
    marginTop: 50,
    padding: 16,
    textAlign: 'center',
  },
  dec: {
    listStyle: 'decimal',
  },
  enphased: {
    color: '#ffcf00',
  },
  enphased2: {
    color: '#7e88c1',
  },
  address: {
    width: '368px',
    height: '40px',
    padding: '0 14px',
    margin: '8px 0',
    border: '2px solid #a0a0a0',
    background: '#000',
    fontSize: '15px',
    color: '#fff',
    lineHeight: '42px',
  },
  mcbutton: {
    width: '368px',
    height: '40px',
    padding: '0 14px',
    margin: '16px 0',
    border: '2px solid #a0a0a0',
    background: '#6d6d6d',
    fontSize: '15px',
    color: '#fff',
    lineHeight: '42px',
    textAlign: 'center',
    textShadow: '2px 2px 0 #383838',
  },
};

export default function Cadeaux() {
  return (
    <Page title="Comment jouer ?">
      <Paper style={style.mc} square>
        <p style={{ textAlign: 'center' }}>
          Pour jouer sur Faction, Skywars, GTA et tous les autres mini-jeux sur BloodyBattle,
          il suffit de se connecter!
        </p>
        <Grid container justify="center" spacing={24}>
          <Grid item md>
            <p>
              <ul style={style.dec}>
                <li>Lancez <span style={style.enphased}>Minecraft 1.7-1.11</span> (ex: 1.8.9)</li>
                <li>
                  Cliquez <span style={style.enphased2}>Multijoueur</span>,
                  puis <span style={style.enphased2}>Nouveau serveur</span>
                </li>
                <li>Ecrivez <span style={style.enphased}>bloodybattle.net</span> dans la barre d{"'"}adresse</li>
                <li>Cliquez <span style={style.enphased2}>Valider</span> et voilà!</li>
                <li>Double-cliquez pour vous connecter</li>
                <li><span style={style.enphased}>Créez un compte / Identifez-vous</span></li>
              </ul>
            </p>
          </Grid>
          <Grid item md>
            <p>
              Adresse du serveur<br />
              <div className="ip" style={style.address}>
                <IPButton style={style.address}>bloodybattle.net</IPButton>
              </div>
              <div style={style.mcbutton}>Valider</div>
            </p>
          </Grid>
        </Grid>
      </Paper>
      <Paper style={style.content} square>
        <Typography variant="h2">Télécharger notre launcher GRATUIT</Typography>
        <p>
          Vous pouvez jouer <bold>GRATUITEMENT</bold> grâce à notre launcher
          (que vous ayez acheté Minecraft ou non).
        </p>
        <Button href="./BloodyBattle.jar" color="secondary" size="large" variant="raised">Télécharger le launcher BloodyBattle.jar</Button><br />
        <small>(compatible Windows/Mac/Linux)</small>
        <p>Lancez Minecraft en version 1.8.9 et rejoingez gratuitement n{"'"}importe quel serveur (avec accès "offline" autorisé).</p>
      </Paper>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Jouer.js